import { render, staticRenderFns } from "./transAcctSauditFail.vue?vue&type=template&id=27c469ce&scoped=true&"
import script from "./transAcctSauditFail.vue?vue&type=script&lang=js&"
export * from "./transAcctSauditFail.vue?vue&type=script&lang=js&"
import style0 from "./transAcctSauditFail.vue?vue&type=style&index=0&id=27c469ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c469ce",
  null
  
)

export default component.exports